<template>
  <div>
    <b-alert variant="danger" :show="criticalError && criticalError != ''">
      <b>KRTISCHER FEHLER</b>
      <br />
      Ein Fehler verhindert das Laden der Bauvisor Anwendung. Bitte kontaktieren Sie den Bauvisor Support.
      <br />
      <br />
      <span class="text-muted">
        <smalL>{{ criticalError }}</smalL>
      </span>
    </b-alert>
    <b-alert variant="info" :show="infoMessage && infoMessage != ''" class="pb-4">
      <img src="@/assets/bv-logo.svg" style="width: 150px; margin-top: 10px; margin-bottom: 20px" />

      <br />
      <h5 class="mb-0">{{ infoMessage }}</h5>

      <br />
      <b-button href="https://www.bauvisor.de/kostenlose-demo/" class="mr-2">Demo Zugang beantragen</b-button>
      <b-button href="https://www.bauvisor.de/kunde-werden/" class="mr-2">Kunde werden</b-button>
      <b-button
        @click="
          $auth.logout({
            returnTo: window.location.origin
          })
        "
        variant="outline-secondary"
      >
        Abmelden
      </b-button>
    </b-alert>

    <!--eslint-disable-->
    <!--- Overlay across the entire viewport --->
    <div
      :class="{
        'd-flex justify-content-center mb-3 loading-spinner-wrapper': AppState.isLoading,
        'd-none': !AppState.isLoading
      }"
    >
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..." id="loadingSpinner"></b-spinner>
        <img src="@/assets/bv-logo-grey.svg" style="margin-top: 150px; width: 150px" />
      </div>
    </div>
    <div id="app" v-if="isLoaded">
      <div id="nav-opener" class="text-muted" v-if="AppState.showNav == false && $route.name != 'Projekt beendet'">
        <small><b-icon icon="chevron-double-right" class="action-button" @click="AppState.showNav = true" /></small>
      </div>
      <SidebarNavigation v-if="!($route.query.nav == 'false') && AppState.showNav == true" />
      <div class="layout-divider d-print-none"></div>
      <div id="main-panel" class="m-0 pt-0" style="overflow: hidden">
        <transition name="fade" mode="out-in">
          <keep-alive>
            <!-- include="<NamePropertyOfComponent>" -->
            <router-view />
          </keep-alive>
        </transition>
      </div>
    </div>
  </div>
</template>

<style>
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: var(--bauvisor-primary) !important;
  background: var(--bauvisor-primary) !important;
}
a:hover {
  color: rgb(var(--bauvisor-primary)) !important;
}
/*
:root {
  --bauvisor-primary: black !important;
}
/*
.custom-control-input:checked ~ .custom-control-label::before,
.custom-control-label:after {
  color: red !important;
  border-color: green !important;
  background-color: black !important;
}
*/
#app {
  display: flex;
  flex-wrap: nowrap;
  height: 100vh;
  height: -webkit-fill-available;
  max-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}

.layout-divider {
  flex-shrink: 0;
  width: 0;
  height: 100vh;
}

#main-panel {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.main-canvas {
  padding: 23px;
  padding-top: 20px;
  padding-bottom: 10px;
}
.page-header h4 {
  margin-bottom: 0px !important;
}
.table-edit-field {
  /* padding-left: 9px !important; */
  background-color: var(--bauvisor-primary-light) !important;
}
.table-edit-field::placeholder {
  color: #899097;
}
.table-edit-field:focus {
  border: 1px solid var(--bauvisor-primary) !important;
  background-color: white !important;
}
.table-input-field {
  padding-left: 8px !important;
  padding-top: 1px !important;
  padding-bottom: 1px !important;
  height: 34px !important;
  border: none !important;
  box-shadow: none !important;
  background-color: var(--bauvisor-primary-light) !important;
  border: 1px solid var(--bauvisor-primary-light) !important;
}

.table-input-field:focus {
  border: 1px solid var(--bauvisor-primary) !important;
  background-color: white !important;
}
.table-sticky-header-hack {
  border-top: 2px solid #dee2e6;
  position: relative;
  top: 2px;
  z-index: 10;
}
.header-search-field .input-group-text {
  background-color: var(--bauvisor-light);
  height: 31px;
  font-size: 12px;
  border: none !important;
}
.header-search-field {
  box-shadow: inset 0 1px 0 rgb(255 255 255 / 15%), 0 1px 1px rgb(0 0 0 / 8%);
}
.header-search-field .form-control {
  border: none !important;
}
.sticky-col {
  position: -webkit-sticky !important;
  position: sticky !important;
}
th.sticky-col {
  z-index: 9;
}
td.sticky-col {
  z-index: 8;
}
.inverted {
  background-color: white !important;
}
.inverted .nav-link.active,
.inverted .router-link-active {
  background-color: var(--bauvisor-light) !important;
  border-bottom: 1px solid var(--bauvisor-light) !important;
}
.nav-tabs:first-child {
  padding-left: 8px;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.loading-spinner-wrapper {
  width: 100%;
  height: 100vh;
  padding-top: 300px;
  position: absolute;
  z-index: 1000;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(245, 245, 245, 0.7);
  animation: fadein 0.4s;
  -moz-animation: fadein 0.4s; /* Firefox */
  -webkit-animation: fadein 0.4s; /* Safari and Chrome */
  -o-animation: fadein 0.4s; /* Opera */
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadein {
  /* Firefox */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  /* Safari and Chrome */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-o-keyframes fadein {
  /* Opera */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.table-wrapper tr:first-child > td {
  border-top: none;
}
.shadow-muted {
  box-shadow: rgb(0 0 0 / 9%) 0px 3.2px 7.2px 0px, rgb(0 0 0 / 7%) 0px 0.6px 1.8px 0px !important;
}
.shadow-muted-super {
  box-shadow: rgb(0 0 0 / 9%) 0px 2.2px 5.2px 0px, rgb(0 0 0 / 7%) 0px 0.6px 1.8px 0px !important;
}
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin-right: 0 !important;
}
.page-header h4 {
  color: #555;
}
.table-edit-field .input-group-text,
.b-table-sticky-header .input-group-text {
  border: none !important;
  background: var(--bauvisor-primary-light) !important;
  padding-right: 9px !important;
  padding-left: 9px !important;
  color: #888;
  height: 34px !important;
}

.form-tabs .nav-tabs:first-child {
  padding-left: 20px !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-active {
  opacity: 0;
}
#loadingSpinner {
  left: calc(50% - 16px);
  position: fixed;
  top: 502px;
}
#nav-opener {
  position: fixed;
  top: 181px;
  left: 0;
  z-index: 1001;
}
</style>

<script>
/* eslint-disable */
import SidebarNavigation from '@/components/SidebarNavigation';
import { getInstance } from './auth';
import projectStore from '@/store/Projects';
import settingsStore from '@/store/Settings';
import ProjectsService from '@/service/ProjectsService';
import UsersService from '@/service/UserService';
import InvoicesService from '@/service/InvoicesService';
import AppState from '@/store/App.js';

var parseSelections = selectionsString => {
  var retVal = null;

  if (selectionsString && selectionsString.length > 0) {
    retVal = selectionsString.replace('\t', '').split(/\r?\n/);
  }

  return retVal; // null or parsed value
};

export default {
  name: 'App',
  data() {
    return {
      AppState,
      isAuthenticated: false,
      isLoaded: false,
      criticalError: null,
      infoMessage: null
    };
  },
  methods: {
    handleGlobalKeyEvents(e) {
      if (e.keyCode == 220 || e.keyCode == 160) {
        AppState.showNav = !AppState.showNav;
      } //else if (e.keyCode == 27) history.back();
    },
    init(cb) {
      // have to do this nonsense to make sure auth0Client is ready
      var instance = getInstance();
      instance.$watch('loading', loading => {
        if (loading === false) {
          if (!instance.isAuthenticated) {
            instance.loginWithRedirect();
          } else {
            const roles = instance.user['https://baucontrolling.ddns.net/roles'];
            this.$root.$user = instance.user;
            this.$root.$user.roles = roles;
            //this.$root.$user.canChange = roles.includes("Planer");
            const host = window.location.hostname.split('.')[0] + instance.user['https://bauvisor.com/srv'];

            this.$root.$user.srv =
              host + '.' + window.location.hostname.split('.')[1] + '.' + window.location.hostname.split('.')[2];

            this.isAuthenticated = true;

            UsersService.getUserPicture()
              .then(image => {
                this.$root.$user.picture = Buffer.from(image).toString();
              })
              .catch(err => (this.$root.$user.picture = null));
            //return 'data:image/gif;base64,R0lGODdhEAAQAMwAAPj7+FmhUYjNfGuxYYDJdYTIeanOpT+DOTuANXi/bGOrWj6CONzv2sPjv2CmV1unU4zPgISg6DJnJ3ImTh8Mtbs00aNP1CZSGy0YqLEn47RgXW8amasW7XWsmmvX2iuXiwAAAAAEAAQAAAFVyAgjmRpnihqGCkpDQPbGkNUOFk6DZqgHCNGg2T4QAQBoIiRSAwBE4VA4FACKgkB5NGReASFZEmxsQ0whPDi9BiACYQAInXhwOUtgCUQoORFCGt/g4QAIQA7';
            //console.log('zzz image', Buffer.from(image).toString());

            cb(instance);
            //} else {
            //              console.log('not alloweds');
            //return (window.location.href = '/notallowed.html');
            //}
          }
        }
      });
    },
    loadProjects() {
      ProjectsService.getProjects()
        .then(async projects => {
          if (projects.length == 0) {
            // user has no role in any project
            AppState.isLoading = false;
            return (this.infoMessage =
              'Ihnen wurden keine Projekte zugewiesen. Bitte wenden Sie sich an den zuständigen Projektleiter.');
          }
          projectStore.projects = projects.map(x => {
            x.ProjectStartDate = this.$utils.SQLDateToBrowserDate(x.ProjectStartDate);

            if (x.ProjectPicture) x.ProjectPicture = Buffer.from(x.ProjectPicture.data).toString();

            if (x.DbId == x.ActiveProjectId) {
              projectStore.activeProject = x;
            }
            return x;
          });
          if (!projectStore.activeProject) {
            // user has no active project
            //const activeProject = await ProjectsService.getActiveProject();
            projectStore.activeProject = projects[0];
          }

          this.$root.$user.isCustomerAdmin =
            projectStore.activeProject && projectStore.activeProject.IsCustomerAdmin == 'true';
          if (projectStore.activeProject && projectStore.activeProject.State == 2) {
            this.$root.$user.mayEnd =
              projectStore.activeProject.IsPlaner == 'true' ||
              projectStore.activeProject.IsAdmin == 'true' ||
              projectStore.activeProject.IsSuperAdmin == 'true';
            this.$root.$user.isPlaner = false;
            this.$root.$user.isAdmin = false;
            this.$root.$user.isSuperAdmin = false;

            this.$root.$user.isReaderOnly = true;
          } else {
            this.$root.$user.isPlaner = projectStore.activeProject && projectStore.activeProject.IsPlaner == 'true';
            this.$root.$user.isAdmin =
              projectStore.activeProject &&
              (projectStore.activeProject.IsAdmin == 'true' || projectStore.activeProject.IsSuperAdmin == 'true');
            this.$root.$user.isSuperAdmin =
              projectStore.activeProject && projectStore.activeProject.IsSuperAdmin == 'true';

            this.$root.$user.isReaderOnly =
              projectStore.activeProject && !(this.$root.$user.isPlaner || this.$root.$user.isAdmin);
          }
          projectStore.projects = projects;
          this.loadProjectSettings();
          this.loadInvoiceTypes();
          this.$eventBus.$on('projectSwitched', () => {
            this.loadProjectSettings();
            if (projectStore.activeProject && projectStore.activeProject.State == 2) {
              this.$root.$user.mayEnd =
                projectStore.activeProject.IsPlaner == 'true' ||
                projectStore.activeProject.IsAdmin == 'true' ||
                projectStore.activeProject.IsSuperAdmin == 'true';
              this.$root.$user.isPlaner = false;
              this.$root.$user.isAdmin = false;
              this.$root.$user.isSuperAdmin = false;

              this.$root.$user.isReaderOnly = true;
            } else {
              this.$root.$user.isPlaner = projectStore.activeProject && projectStore.activeProject.IsPlaner == 'true';
              this.$root.$user.isAdmin =
                projectStore.activeProject &&
                (projectStore.activeProject.IsAdmin == 'true' || projectStore.activeProject.IsSuperAdmin == 'true');
              this.$root.$user.isSuperAdmin =
                projectStore.activeProject && projectStore.activeProject.IsSuperAdmin == 'true';

              this.$root.$user.isReaderOnly =
                projectStore.activeProject && !(this.$root.$user.isPlaner || this.$root.$user.isAdmin);
            }

            localStorage.setItem('projectTab', 'project');
          });
        })
        .catch(error => {
          AppState.isLoading = false;

          if (error.response && error.response.status && error.response.status == 403) {
            this.infoMessage =
              'Der angemeldete Benutzer existiert nicht in Bauvisor oder wurde keinem Projekt zugeordnet.';
          } else {
            this.criticalError = error.toString();
            this.$showError(this, error.toString());
          }
        });
    },
    loadProjectSettings() {
      settingsStore.settings = []; // kill all existing settings
      //if (projectStore.activeProject) projectStore.activeProject.ProjectPicture = null;
      ProjectsService.getProjectSettings()
        .then(settings => {
          settings.map(x => (settingsStore.settings[x.SettingsKey] = x.SettingsValue));
          settingsStore.settings['Centbetraege'] = settingsStore.settings['Centbetraege'] == 'true' ? true : false;
          //console.log("zzzb settingsStore.settings", settingsStore.settings)
          // selections come as string from database. b-select expect it as an array. need to split it.
          settingsStore.settingsParsed['KGR_Selections_Parsed'] = parseSelections(
            settingsStore.settings['KGR_Selections']
          );
          settingsStore.settingsParsed['Responsible_Selections_Parsed'] = parseSelections(
            settingsStore.settings['Responsible_Selections']
          );
          settingsStore.settingsParsed['FA1_Selections_Parsed'] = parseSelections(
            settingsStore.settings['FA1_Selections']
          );
          settingsStore.settingsParsed['FA2_Selections_Parsed'] = parseSelections(
            settingsStore.settings['FA2_Selections']
          );
          this.isLoaded = true;
          AppState.isLoading = false;
        })
        .catch(err => (this.criticalError = err.toString()));
    },
    loadInvoiceTypes() {
      InvoicesService.getInvoiceTypes()
        .then(types => {
          AppState.invoiceTypes = types;
        })
        .catch(error => {
          console.log(error);
          AppState.isLoading = false;
          this.criticalError = error.toString();
          this.$showError(this, error.toString());
        });
    }
  },
  created() {
    this.init(this.loadProjects);
    window.addEventListener('keydown', this.handleGlobalKeyEvents);
    this.$root.$on('bv::collapse::state', (id, state) => {
      localStorage.setItem(id, state);
    });
  },
  components: {
    SidebarNavigation
  }
};
</script>
